"use client";
import { useMovementDetection } from "@/components/useMouseMovement";
import dynamic from "next/dynamic";
import React, { useEffect, useState } from "react";

type iFrameLoaderProps = {
        videoId: string;
    options?: {
        alt?: string;
        className?: string;
        allowFullScreen?: boolean;
    };
};

const skeletonLoader = () => {
    return <div className="bg-gray-100 h-full w-full rounded-3xl" />;
}

const IFrameLoader = ({ videoId, options }: iFrameLoaderProps) => {
    const [showComponent, setShowComponent] = useState(false);
    const hasInteracted = useMovementDetection();
    useEffect(() => {
        if (hasInteracted) {
            setShowComponent(true);
        }
    }, [hasInteracted]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowComponent(true);
        }, 5000);

        return () => clearTimeout(timer);
    }, []);

    return showComponent ? (
        <iframe
            src={videoId}
            title={options?.alt}
            className={options?.className}
            {...(options?.allowFullScreen && { allowFullScreen: options?.allowFullScreen })}
        />
    ) : (
        skeletonLoader()
    );
};

export default IFrameLoader;
